import { render } from "./MultiselectItem.vue?vue&type=template&id=e6ec2d1a&scoped=true"
import script from "./MultiselectItem.vue?vue&type=script&lang=js"
export * from "./MultiselectItem.vue?vue&type=script&lang=js"

import "./MultiselectItem.vue?vue&type=style&index=0&id=e6ec2d1a&scoped=true&lang=css"

import exportComponent from "../../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6ec2d1a"]])

export default __exports__